import React from 'react';
import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel';
import { useTranslation } from 'react-i18next';
import { truncate } from 'lodash';

import { 
  Card, 
  makeStyles, 
  CardMedia, 
  useTheme 
} from '@material-ui/core';
import FlagIcon from '@material-ui/icons/Flag';

import './css/challengeBanner.css';
import imageCard from '../../assets/imgs/imagem_padrao_card_desafio.png';
import { history } from '../../helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    // margin: theme.spacing(2, 0),
  },
  row: { 
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    border: '1px solid',
    borderColor: theme.palette.grey.main,
  },
  column: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.neutrals.low.main,
  },
  link: {
    fontSize: 12,
    cursor: 'pointer',
    color: theme.palette.grey.darkest,
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
  slider: {
    maxHeight: '250px',
    borderRadius: 8,
    border: '1px solid',
    borderColor: theme.palette.grey.main,
  },
  slide: {
    [theme.breakpoints.down('sm')]: {
      maxHeight: '130px',
    },
  },
  slideImage: {
    cursor: 'pointer',
  },
  cardMedia: {
    width: '100%',
    paddingTop: '56.25%',
  },
  dotGroup: {
    textAlign: 'center',
  },
  contentInner: {
    width: "100%",
    padding: "1rem",
    position: "sticky",
    background: theme.palette.neutrals.high.main,
    bottom: 0,
  },
  titleBanner: {
    color: theme.palette.neutrals.low.main,
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: 17,
    textTransform: 'lowercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  description: {
    color: theme.palette.neutrals.low.light,
    fontSize: '12px',
    fontWeight: 500,
    wordBreak: 'break-word',
    textTransform: 'lowercase',
  },
  badgeStatus: {
    position: 'absolute',
    top: 16,
    left: 16,
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    padding: 5,
    borderRadius: 4,
    color: theme.palette.neutrals.high.main,
    backgroundColor: theme.palette.auxiliary.cyan.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 8,
    },
  },
}));

function ChallengeBanner({ challenges }) {
  const classes = useStyles();
  const theme = useTheme();

  const { t } = useTranslation();

  function goToChallenge(id) {
    history.push(`/challenge/detail/${id}`);
  }

  challenges = challenges.filter(x => x.statusChallenge?.code === 4);

  return (
    <div className={classes.root}>
      <Card className={classes.row} elevation={0}>
        <div className={classes.column}>
          <FlagIcon style={{ color: theme.palette.auxiliary.blue.main, marginRight: 6 }} />
          <div className={classes.title}>{t('desafios')}</div>
        </div>
        <div>
          <div
            className={classes.link}
            onClick={() => history.push('/challenges')}
          >
            {t('ver_todos')}
          </div>
        </div>
      </Card>

      <div>
        <CarouselProvider
          visibleSlides={1}
          totalSlides={challenges?.length}
          step={1}
          naturalSlideWidth={400}
          naturalSlideHeight={450}
        >
          <Slider className={classes.slider} >
            {challenges?.length > 0 &&
              challenges.map((challenge, index) => (

                <Slide
                  innerClassName={classes.slide}
                  index={index}
                  key={index}
                  onClick={() => goToChallenge(challenge._id)}
                >
                  <div className={classes.slideImage}>
                    <CardMedia
                      image={
                        challenge.attachment?.url
                          ? challenge.attachment.url
                          : imageCard
                      }
                      className={classes.cardMedia}
                    />
                    <div className={classes.badgeStatus}>{t('em_andamento')}</div>
                  </div>
                    <div className={classes.contentInner}>
                      <div className={classes.titleBanner}>
                        {truncate(challenge.name, { length: 24, separator: '...' })}
                      </div>
                      <div className={classes.description}>
                        {truncate(challenge.description, { length: 103, separator: '...' })}
                      </div>
                    </div>
                </Slide>
              ))}
          </Slider>
          <DotGroup className={classes.dotGroup}></DotGroup>
        </CarouselProvider>
      </div>
    </div>
  );
}

export { ChallengeBanner };
